export default "__VITE_ASSET__BevW9NWl__"